const ENEntertainment = [
    {
        title: 'Kim Kardashian’s KKW Beauty gets a $1 billion valuation, but that’s 15% less than Kylie Jenner’s beauty brand',
        description: 'The difference between being one of the most recognized people in the world and being one of the most admired is worth about $180 million dollars, according to global beauty company Coty. Inc.',
        url: 'https://www.marketwatch.com/story/kim-kardashian-wests-beauty-business-is-valued-about-180-million-less-than-kylie-jenners-2020-06-29',
        image: 'https://s.marketwatch.com/public/resources/images/MW-IJ496_Kim_Ky_ZG_20200629112825.jpg',
        publishedAt: '2020-06-29T19:42:45Z',
        source: {
            name: 'Market Watch',
            url: 'https://www.marketwatch.com/'
        }
    },
    {
        title: 'Chase Rice criticized for packed concert',
        description: 'Country singer Chase Rice is facing criticism from his fellow musicians after video of a concert this weekend showed a large group of attendees squeezed in together and not wearing face coverings.',
        url: 'https://edition.cnn.com/2020/06/29/entertainment/chase-rice-concert-covid-trnd/index.html',
        image: 'https://cdn.cnn.com/cnnnext/dam/assets/200629111920-chase-rice-2019-restricted-super-tease.jpg',
        publishedAt: '2020-06-29T19:33:50Z',
        source: {
            name: 'CNN',
            url: 'https://edition.cnn.com/'
        }
    },
    {
        title: 'Hulu removes "Golden Girls" mud mask episode, prompting pushback: "What the hell?"',
        description: "Hulu has removed a 1988 episode of The Golden Girls' in which actresses Betty White and Rue McClanahan wear black mud on their faces, according to several reports on Monday, with the decision prompting backlash on social media. In the episode in question, titled 'Mixed Blessing,' the son of Bea Arthurs Dorothy plans to marry an older Black woman played by Rosalind Cash.",
        url: 'https://thehill.com/homenews/media/505086-hulu-removes-golden-girls-mud-mask-episode-prompts-pushback-what-the-hell',
        image: 'https://thehill.com/sites/default/files/hulu_062920getty.jpg',
        publishedAt: '2020-06-29T19:33:29Z',
        source: {
            name: 'The Hill',
            url: 'https://thehill.com/'
        }
    },
    {
        title: 'Rachel Cargle and Lin-Manuel Miranda Find Parallels Between HAMILTON Lyrics and Current-Day News Headlines',
        description: 'Rachel Cargle shared via Facebook, that she and Lin-Manuel Miranda worked together to find parallels between Hamilton lyrics and the current times to bring attention to everything going on in the world at this moment in time.',
        url: 'https://www.broadwayworld.com/article/Rachel-Cargle-and-Lin-Manuel-Miranda-Find-Parallels-Between-HAMILTON-Lyrics-and-Current-Day-News-Headlines-20200629',
        image: 'https://cloudimages.broadwayworld.com/columnpiccloud/1250-d6823d5dab1c6588bd396b1621942a80.jpg',
        publishedAt: '2020-06-29T19:21:14Z',
        source: {
            name: 'Broadway World',
            url: 'https://www.broadwayworld.com/'
        }
    },
    {
        title: 'AMC Theatres Shifts Reopening Date To July 30 After ‘Tenet’ & ‘Mulan’ Delay',
        description: 'As expected with NYC and LA cinemas still not opened, and Tenet, the first big event pic heading to Aug. 12, the No. 1 exhibitor in the U.S., Europe and the Middle East, AMC, will now reopen its circuit on July 30 instead of July 15. On the new date, the Leawood, KS-based chain will resume operations of 450 U.S. theatres as part of its phased plan to bring its 600-plus multiplexes back on line by early August.',
        url: 'https://deadline.com/2020/06/amc-theatres-reopening-new-date-tenet-mulan-1202972756/',
        image: 'https://pmcdeadline2.files.wordpress.com/2020/06/amc-burbank.jpg?w=1024',
        publishedAt: '2020-06-29T18:30:29Z',
        source: {
            name: 'Deadline',
            url: 'https://deadline.com/'
        }
    },
    {
        title: "Joseph James DeAngelo Jr. pleads guilty to murders tagged to California's Golden State Killer",
        description: 'A former police officer accused of terrorizing California as a serial burglar and rapist and killing more than a dozen people while evading capture for decades pleaded guilty Monday to murders attributed to a criminal dubbed the Golden State Killer. Joseph James DeAngelo, who was arrested in 2018, had remained almost silent in court until he uttered the word “guilty” in a hushed and raspy voice multiple times.',
        url: 'https://eu.usatoday.com/story/news/nation/2020/06/29/alleged-golden-state-killer-joseph-deangelo-set-plead-guilty-monday-sacramento/3279438001/',
        image: 'https://www.gannett-cdn.com/presto/2020/06/29/PPAS/547b1339-6b48-4a00-8899-b71c1258066c-AP20181600864804.jpg?crop=4206,2366,x0,y214&width=3200&height=1680&fit=bounds',
        publishedAt: '2020-06-29T18:17:10Z',
        source: {
            name: 'USA Today',
            url: 'https://eu.usatoday.com/'
        }
    },
    {
        title: 'Shane Dawson is the latest big YouTuber to apologize for racist videos',
        description: "By now, the garden variety YouTube apology is an easily recognizable art form: Puffy eyes, a sparse background, a vague title -- and in the middle of it, a famous creator who's done something very, very wrong. The latest star to tread this familiar road is also one of the platform's earliest success stories.",
        url: 'https://edition.cnn.com/2020/06/29/entertainment/shane-dawson-youtube-apology-video-racism-trnd/index.html',
        image: 'https://cdn.cnn.com/cnnnext/dam/assets/200629123355-shane-dawson-2016-super-tease.jpg',
        publishedAt: '2020-06-29T18:14:41Z',
        source: {
            name: 'CNN',
            url: 'https://edition.cnn.com/'
        }
    },
    {
        title: 'Sequel, Brides Pilot Not Moving Forward at ABC',
        description: 'A trio of ABC pilots received bad news on Monday: thirtysomething(else), Brides and Valley Trash will not be moving forward at the network, TVLine has learned. thirtysomething(else) would have served as a sequel to the Alphabet Net’s 1987 drama thirtysomething, with original series creators Marshall Herskovitz and Ed Zwick back to write and direct.',
        url: 'https://tvline.com/2020/06/29/thirtysomething-sequel-cancelled-abc-pilot-not-moving-forward/',
        image: 'https://pmctvline2.files.wordpress.com/2020/06/thirtysomething-sequel-cancelled.jpg?w=620',
        publishedAt: '2020-06-29T18:02:11Z',
        source: {
            name: 'TV Line',
            url: 'https://tvline.com/'
        }
    },
    {
        title: '"Into the Night" singer Benny Mardones dead at 73',
        description: 'Benny Mardones, the musician best known for his 1980 smash hit “Into the Night,” has died after a 20-year battle with Parkinson’s disease. He was 73. The singer’s death was confirmed to Billboard by longtime friend and record producer Joel Diamond, who noted he died at his home in Menifee, Calif.',
        url: 'https://www.foxnews.com/entertainment/into-the-night-benny-mardones-dead-73',
        image: 'https://static.foxnews.com/foxnews.com/content/uploads/2020/06/BennyM1.jpg',
        publishedAt: '2020-06-29T18:00:42Z',
        source: {
            name: 'FOX News',
            url: 'https://www.foxnews.com/'
        }
    },
    {
        title: 'Sacha Baron Cohen’s Latest Prank Involved Crashing an Alt-Right Rally For a Racist Singalong',
        description: 'It looks like Sacha Baron Cohen is at it again. The notorious provocateur and satirist, who has built up a reputation for pranking real people while in disguise for his projects, has apparently staged his latest prank at an alt-right rally.',
        url: 'https://www.slashfilm.com/sacha-baron-cohen-prank-involved-alt-right-rally/',
        image: 'https://d13ezvd6yrslxm.cloudfront.net/wp/wp-content/images/sacha-baron-cohen-2-e1593446717686.jpg',
        publishedAt: '2020-06-29T18:00:27Z',
        source: {
            name: 'Slash Film',
            url: 'https://www.slashfilm.com/'
        }
    },
    {
        title: 'John Oliver Explains Why the Rent Crisis Could Make the Pandemic Even Worse',
        description: 'With the numbers of COVID-19 infections spiking in several parts of America, many states are reversing their reopenings and sending residents back to their homes. But those homes are only safe harbors if people can hold onto them.',
        url: 'https://slate.com/culture/2020/06/john-oliver-last-week-tonight-evictions-coronavirus.html',
        image: 'https://compote.slate.com/images/93590816-38bb-4e60-a3e8-74ce189d7c74.jpeg',
        publishedAt: '2020-06-29T17:50:35Z',
        source: {
            name: 'Slate',
            url: 'https://slate.com/'
        }
    },
    {
        title: 'Shawn Johnson Recalls Road to Recovery After Eating Disorder, Pill "Overdosing" and Miscarriage',
        description: 'The famed gymnast and Olympic gold medalist was referring to her journey to recovery after battling with "perfection" and the toll it took on her—a journey she revisited in depth in a new video posted to her YouTube account titled, "body image issues: 110lbs to pregnant."',
        url: 'https://www.eonline.com/news/1165969/shawn-johnson-recalls-road-to-recovery-after-eating-disorder-pill-quot-overdosing-quot-and-miscarriage',
        image: 'https://akns-images.eonline.com/eol_images/Entire_Site/2020529/rs_600x600-200629082854-600-Shawn-Johnson-JR-62920.jpg?fit=around|1080:1080&output-quality=90&crop=1080:1080;center,top',
        publishedAt: '2020-06-29T17:49:35Z',
        source: {
            name: 'E Online',
            url: 'https://www.eonline.com/'
        }
    },
    {
        title: 'Dr.Dre and wife divorcing after 24 years of marriage',
        description: "Dr. Dre and his wife of 24 years are moving on to 'the next episode' in their lives. On Monday, Nicole Young, who married the hip-hop mogul in 1996, filed divorce paperwork, citing irreconcilable differences as the reason for the split, TMZ reported.",
        url: 'https://www.wonderwall.com/news/dr.-dre-and-wife-divorcing-after-24-years-of-marriage-362548.article',
        image: 'https://i0.wp.com/www.wonderwall.com/wp-content/uploads/sites/2/2020/06/shutterstock_editorial_9928227f.jpg?crop=0px%2C0px%2C3000px%2C1575px&resize=1200%2C630&ssl=1',
        publishedAt: '2020-06-29T17:48:00Z',
        source: {
            name: 'Wonder Wall',
            url: 'https://www.wonderwall.com/'
        }
    },
    {
        title: 'Milton Glaser’s Unseen Design for New York: ‘Together’',
        description: 'Five weeks ago, I received a call from Milton Glaser. We’d never met, but he was kindly answering an email I’d sent his studio a few hours prior. At best, I expected a response from his assistant. Instead, I got a FaceTime Audio call from the 90-year-old graphic designer.',
        url: 'https://www.nytimes.com/2020/06/29/arts/design/milton-glaser-together-design-coronavirus.html',
        image: 'https://static01.nyt.com/images/2020/06/30/arts/29glaser-unseen/29glaser-unseen-facebookJumbo.jpg',
        publishedAt: '2020-06-29T17:30:00Z',
        source: {
            name: 'NY Times',
            url: 'https://www.nytimes.com/'
        }
    },
    {
        title: "Will Ferrell on the origins of 'Jaja Ding Dong,' Eurovision Song Contest's catchiest cut",
        description: 'Will Ferrell isn’t just the star of Eurovision Song Contest: The Story Of Fire Saga. He’s also its writer and producer. He even birthed the initial idea for the story after a late ‘90s viewing of the contest with his wife’s Swedish family.',
        url: 'https://film.avclub.com/will-ferrell-on-the-origins-of-jaja-ding-dong-eurovi-1844171175',
        image: 'https://i.kinja-img.com/gawker-media/image/upload/c_fill,f_auto,fl_progressive,g_center,h_675,pg_1,q_80,w_1200/mhezqn8yh430ihsezzpy.jpg',
        publishedAt: '2020-06-29T17:30:00Z',
        source: {
            name: 'AVClub',
            url: 'https://film.avclub.com/'
        }
    },
    {
        title: 'Broadway’s Coronavirus Shutdown Officially Extends Until January 2021',
        description: 'The Broadway League has officially confirmed what has already seemed apparent: Due to the coronavirus pandemic, Broadway theater won’t be able to come back until at least 2021. The league, a consortium of Broadway producers and theater owners, announced today that it will suspend performances through January 2, 2021.',
        url: 'http://www.vulture.com/2020/06/broadway-shutdown-officially-extends-until-january-2021.html',
        image: 'https://pyxis.nymag.com/v1/imgs/941/777/f0da84406042e3e2ae7b66ba4f8d7efec9-broadway-closed.1x.rsocial.w1200.jpg',
        publishedAt: '2020-06-29T17:20:36Z',
        source: {
            name: 'Vulture',
            url: 'https://www.vulture.com/'
        }
    },
    {
        title: "Kanye West Announces First Single Off Of 'God's Country' Dropping Today",
        description: "The #WestDayEver has officially extended over the weekend with the release of what appears to be a new single. Kanye West hit Twitter earlier today, following a string of announcements on Friday, to announce his new album God's Country. Along with the album announcement, he shared a snippet of a new song which he said would be arriving later today.",
        url: 'https://www.hotnewhiphop.com/kanye-west-announces-first-single-off-of-gods-country-dropping-today-news.113434.html',
        image: 'https://www.hotnewhiphop.com/image/740x416/cover/1593447429_97ede6c4361f6de64a7a43b7981c87e2.jpg/43025f02e3806d5674a7c8987696ecdc/1593447429_89f328cf07cba6caafef889d0e191cea.jpg',
        publishedAt: '2020-06-29T17:16:23Z',
        source: {
            name: 'HNHH',
            url: 'https://www.hotnewhiphop.com/'
        }
    },
    {
        title: 'Watch Ryan Reynolds troll Hugh Jackman by crashing a virtual X-Men cast reunion',
        description: "It may seem hard to believe since time feels broken during the ongoing COVID-19 pandemic, but it has been 20 whole years since the first X-Men movie changed superhero movies forever. Original stars Hugh Jackman, Halle Berry, Patrick Stewart, and Famke Janssen got together on a Zoom call to celebrate the occasion, but then found some of the franchise's newest stars butting in.",
        url: 'https://ew.com/movies/ryan-reynolds-crashes-virtual-x-men-reunion/',
        image: 'https://imagesvc.meredithcorp.io/v3/mm/image?q=85&c=sc&poi=face&w=1500&h=785&url=https%3A%2F%2Fstatic.onecms.io%2Fwp-content%2Fuploads%2Fsites%2F6%2F2020%2F06%2F29%2Fryan-reynolds.jpg',
        publishedAt: '2020-06-29T17:09:31Z',
        source: {
            name: 'EW',
            url: 'https://ew.com/'
        }
    },
    {
        title: "Colin Kaepernick and Ava DuVernay announce new Netflix series about football player's life",
        description: 'Colin Kaepernick and Ava DuVernay are teaming up for a new project on Netflix. The director and athlete/activist announced they are working on a new scripted limited series, "Colin in Black & White," which will focus on Kaepernick’s "formative high school years, lending meaningful insight into the acts and experiences that led him to become the activist he is today."',
        url: 'https://www.foxnews.com/entertainment/colin-kaepernick-ava-duvernay-series-netflix',
        image: 'https://static.foxnews.com/foxnews.com/content/uploads/2020/06/Colin-Kaepernick-AP-Ava-Duvernay-2018-Invision.jpg',
        publishedAt: '2020-06-29T17:08:09Z',
        source: {
            name: 'FOX News',
            url: 'https://www.foxnews.com/'
        }
    },
    {
        title: "Kate and William's 'family rules' - with bans on shouting and no TV before tea",
        description: 'Kate Middleton and Prince William reportedly have a strict set of "family rules", including bans on shouting and watching TV before dinner. The Duke and Duchess of Cambridge are said to insist on their children Charlotte, Louis and George never going to bed angry. Instead they are encouraged to share what is upsetting them and talk about their feelings so the family can move forward.',
        url: 'https://www.mirror.co.uk/news/uk-news/kate-williams-family-rules-bans-22273615',
        image: 'https://i2-prod.mirror.co.uk/incoming/article22273765.ece/ALTERNATES/s1200/0_BBC-Children-In-Need-and-Comic-Relief-Big-Night-In.jpg',
        publishedAt: '2020-06-29T22:35:10Z',
        source: {
            name: 'Mirror',
            url: 'https://www.mirror.co.uk/'
        }
    }
]


export default ENEntertainment;